/* eslint-disable no-console */
import {Col, Form, Select} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import React, {useMemo} from 'react';

import {CommonErrors, processTypeFilter} from '../../../../constants/Common';
import useCompanyStore from '../../../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../../../store/StaticJson/jsonStore';
import {FacilityKey} from '../../Constants/IP/FacilityKeyLabel';
import {
  ProductInfoKey,
  ProductInfoLabel
} from '../../Constants/Products/ProductInfoKeyLabel';
import {filterSelectOptions} from '../commonFunctions';

const ProductFacility: React.FC<{
  name?: any;
  mainName?: string;
}> = ({name, mainName}) => {
  const {processType} = useJSONStore.getState();
  const {getFieldValue} = useFormInstance();
  const facilities =
    useCompanyStore
      .getState()
      .facilityDetails?.[getFieldValue('year') ?? '']?.filter((item: any) => {
        return !item?.[FacilityKey.LEASED];
      }) ?? [];

  const facilityYearWise = useMemo(() => {
    return facilities?.map((item: any) => {
      return {value: item?._id, label: item?.[FacilityKey.FACILITY_NAME]};
    });
  }, [facilities]);

  const filterSelectOption = (value: any) => {
    return facilityYearWise.filter((item: any) => {
      return !getFieldValue(mainName)?.some((tableItem: any) => {
        return value
          ? tableItem?.[ProductInfoKey.SINGLE_FACILITY] === item?.value &&
              value !== item.value
          : tableItem?.[ProductInfoKey.SINGLE_FACILITY] === item?.value;
      });
    });
  };

  return (
    <>
      <Col className="gutter-row" span={12}>
        <Form.Item
          name={[name, ProductInfoKey.SINGLE_FACILITY]}
          rules={[
            {
              required: true,
              message: CommonErrors.mandatory(ProductInfoLabel.SINGLE_FACILITY)
            }
          ]}
          label={ProductInfoLabel.SINGLE_FACILITY}
          labelCol={{span: 24}}
          validateFirst
          hasFeedback
        >
          <Select
            showSearch
            allowClear
            className="select"
            placeholder={`Choose ${ProductInfoLabel.SINGLE_FACILITY}`}
            filterOption={filterSelectOptions}
            options={filterSelectOption(
              getFieldValue([mainName, name, ProductInfoKey.SINGLE_FACILITY])
            )}
          />
        </Form.Item>
      </Col>
      {processTypeFilter() && (
        <Col className="gutter-row" span={12}>
          <Form.Item
            name={[name, ProductInfoKey.processType]}
            rules={[]}
            label={ProductInfoLabel.processType}
            labelCol={{span: 24}}
            validateFirst
            hasFeedback
          >
            <Select
              showSearch
              allowClear
              mode="multiple"
              className="select"
              placeholder={`Choose ${ProductInfoLabel.processType}`}
              filterOption={filterSelectOptions}
              options={processType}
            />
          </Form.Item>
        </Col>
      )}
    </>
  );
};

export default ProductFacility;
